<template>
  <div>
    <!-- <v-select v-model="selected" /> -->
    <InputSelect v-model="selected" v-bind="$attrs" @input="onInput"></InputSelect>
    <ul class="list-unstyled p-0 my-1">
      <li v-for="(item, index) in selecteds" :key="item.idVehiculo" class="font-weight-bold mb-1">
        <button @click="onDeleteItem(item, index)" class="btn btn-sm btn-icon text-danger">
          <span class="fa fa-fw fa-times"></span>
        </button>
        {{ item[$attrs.label] }}
      </li>
    </ul>
  </div>
</template>
<script>
import InputSelect from "../modules/shared/components/InputSelect.vue";
export default {
  components: { InputSelect },
  props: ["value"],
  data() {
    return {
      selected: null,
      selecteds: [],
    };
  },
  watch: {
    value(newVal, oldVal) {
      let vm = this;
      vm.selecteds = vm.$attrs.options.filter((item) => newVal.includes(String(item[vm.$attrs.id])));
    },
  },
  created() {
    let vm = this;
    if (vm.value.length) {
      vm.selecteds = vm.$attrs.options.filter((item) => vm.value.includes(String(item[vm.$attrs.id])));
    }
  },
  methods: {
    onInput(val) {
      let vm = this;
      if (!val) {
        vm.selected = null;
        return;
      }
      let filter = vm.selecteds.filter((item) => String(item[vm.$attrs.id]) == String(val[vm.$attrs.id]));

      if (filter.length > 0) {
        vm.selected = null;
        return;
      }

      vm.selecteds.push(val);
      vm.selected = null;
      this.onUpdate();
    },
    onDeleteItem(item, index) {
      this.selecteds.splice(index, 1);
      this.onUpdate();
    },
    onUpdate() {
      let vm = this;
      vm.$emit(
        "input",
        vm.selecteds.map((item) => String(item[vm.$attrs.id]))
      );
    },
  },
};
</script>
